import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

import AppShell from "../../components/layout/AppShell";
import { settingsNavItems, navItemIsActive } from "../../config/nav";

const SettingsLayout = ({ currentUser }) => {
  const location = useLocation();
  const match = settingsNavItems.find((item) => navItemIsActive(location.pathname, item.path));
  const pageTitle = match?.label || "Settings";

  return (
    <AppShell currentUser={currentUser} pageTitle={pageTitle} pageSubtitle="Settings">
      <div className="max-w-3xl space-y-6">
        <div className="hidden md:block">
          <h1 className="font-display font-bold italic text-[40px] leading-[1.1] text-theme-on-background">Settings</h1>
          <p className="font-mono text-[12px] text-theme-dim mt-1 uppercase tracking-[0.08em]">
            Brands, replies, mailboxes, and appearance.
          </p>
        </div>
        <div className="flex flex-wrap gap-2 border-b border-theme-border pb-4">
          {settingsNavItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `rounded px-3 py-2 font-mono text-[11px] uppercase tracking-[0.06em] transition-colors ${
                  isActive
                    ? "bg-theme-panel text-theme-accent border border-theme-accent/40"
                    : "text-theme-muted border border-transparent hover:border-theme-border hover:text-theme-text"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>
        <Outlet context={{ currentUser }} />
      </div>
    </AppShell>
  );
};

export default SettingsLayout;
